import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SPA のルート遷移では前ページのスクロール位置が引き継がれる。
// 別ページ (pathname が変わる遷移) では必ず先頭に戻す。
export default function ScrollToTop() {
  const { pathname } = useLocation();

  // 戻る/進む操作でブラウザが前回位置を復元してから
  // useEffect でトップに戻ると二段階の動きになるため、
  // 自動復元を無効化して SPA 側で一元管理する。
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
}
